import { render, staticRenderFns } from "./ListaProcesos.vue?vue&type=template&id=3527ef86&scoped=true"
import script from "./ListaProcesos.vue?vue&type=script&lang=js"
export * from "./ListaProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3527ef86",
  null
  
)

export default component.exports